export const State = {
  // For existing pet retrieved from the backend
  Active: 'Active',
  // For a newly created pet that has been submitted into the backend (like on /add-pet flow)
  NotActive: 'NotActive',
  // For a newly created pet (not yet submitted into the backend like on signup flow)
  Pending: 'Pending',
} as const;
